import { render, staticRenderFns } from "./AppContactsLinkRuleInfo.vue?vue&type=template&id=b068ab90&scoped=true"
import script from "./AppContactsLinkRuleInfo.vue?vue&type=script&lang=js"
export * from "./AppContactsLinkRuleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b068ab90",
  null
  
)

export default component.exports